import React from 'react';
import { Badge, BadgePriority } from 'wix-ui-tpa';
import ClockSmall from 'wix-ui-icons-common/on-stage/ClockSmall';
import { classes } from './status-badge.st.css';

export const StatusBadge = ({
  text,
  'aria-label': ariaLabel,
}: {
  text: string;
  'aria-label': string;
}) => (
  <Badge
    className={classes.root}
    priority={BadgePriority.secondary}
    icon={<ClockSmall />}
    aria-label={ariaLabel}
  >
    {text}
  </Badge>
);
